/* Replace "Here's " → "Woohoo! You got "
   and append '!' once the ReferralCandy popup loads            */
(function () {
  function transformText() {
    const p = document.querySelector('.rc-efop-header > p');
    if (!p) return false;                       // Popup not in DOM yet

    let txt = p.textContent.trim();

    // 1. Swap the intro phrase (case-insensitive, handles ’ or ')
    txt = txt.replace(/^here[’']?s\s+/i, 'Woohoo! You got ');

    // 2. Ensure exactly one exclamation mark at the end
    txt = txt.replace(/!+$/, '') + '!';

    p.textContent = txt;
    return true;
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (transformText()) return;                // It was already in the DOM

    const obs = new MutationObserver(() => {
      if (transformText()) obs.disconnect();    // Found it—stop watching
    });

    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
